import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorCode, Exception } from 'exception/Exception';
import { ContactListSendModel, ContactListDistributionType } from 'api/dto/ContactList.dto';
import { selectContactListDistributionType } from 'reduxStore/contactList/selectors';
import { clearContactList } from 'reduxStore/contactList/slice';
import { selectEmailDistributionId } from 'reduxStore/emailDistribution/selectors';
import { selectKioskDistributionId } from 'reduxStore/kioskDistribution/selectors';
import { serializeError } from 'shared/utils/redux';
import { contactListApi } from 'container/contactListApi';

import { STORE_NAME } from './initialState';

export const fetchContactList = createAsyncThunk(
  `${STORE_NAME}/fetchContactList`,
  async ({ distributionId }: { distributionId: string }) => {
    try {
      return await contactListApi.fetch(distributionId);
    } catch (error) {
      if ((error as Exception).getCode() === ErrorCode.ENTITY_NOT_FOUND) {
        // handle not-existing contact list as another case, not exception
        return null;
      }

      throw error;
    }
  },
  { serializeError },
);

export const createContactList = createAsyncThunk(
  `${STORE_NAME}/createContactList`,
  async ({ contactList }: { contactList: ContactListSendModel }, { dispatch, getState }) => {
    const id =
      selectContactListDistributionType(getState()) === ContactListDistributionType.Email
        ? selectEmailDistributionId(getState())
        : selectKioskDistributionId(getState());

    const result = await contactListApi.create(id, contactList);
    dispatch(clearContactList());
    return result;
  },
  { serializeError },
);
